import React, { Component, PropTypes } from 'react'
import { connect } from 'react-redux'
import CSSModules from 'react-css-modules'
import Loader from 'react-loader'
import {Row, Col} from 'react-flexbox-grid'
import format from '../../helpers/format'
import config from '../../config'
import * as searchActions from 'redux/modules/search'
import {
  Link,
  LinkIcon,
  Grade,
  TargetDateLinks
} from '../../components'
import Styles from './SjfTargetDateGrid.css'


@CSSModules(Styles, {allowMultiple:true})
class TargetDateGridItem extends Component {
  static propTypes = {
    fund: PropTypes.object.isRequired,
    funds: PropTypes.array
  }

  constructor(props){
    super(props)
    this.state = {
      url: this.makeUrl(props.fund),
    }
  }

  makeUrl = (fund) => {
    const sName = format.sanitize(fund.fund_legal_name)
    const sTicker = fund.ticker || 'N'
    return config.routes.fund + '/' +
      sName + '/' +
      sTicker + '/' + config.profilePath + '/' +
      fund.fund_id + '/' +
      fund.investment_vehicle_id
  }
  //
  render() {
    return <div styleName='target-date-grid-item'>
      <div styleName='target-date-grid-item__strategy_links'>
        <Link
          to={this.state.url}
          title={this.props.fund.strategy_name + ' 2050'}
        >
          <h3 styleName='target-date-grid-item__name'>
            <b>{ this.props.fund.strategy_name }</b>
            {
              this.props.fund.sustainable_investment ?
                <span styleName='target-date-grid-item__leaf'>
                  <LinkIcon faclass='fa-leaf' />
                </span> :
                null
            }
          </h3>
        </Link>
        <TargetDateLinks
          funds={this.props.funds}
          strategyName={this.props.fund.strategy_name}
        />
      </div>
      <div styleName='target-date-grid-item__grades-wrap'>
        <p styleName='target-date-grid-item__grades-label'>
            Equity & Justice Grades for 2050 Fund
        </p>
        <div styleName='target-date-grid-item__grades'>

          <div styleName='target-date-grid-item__grade'>
            <p styleName='target-date-grid-item__grade-title'>
              Gender Equality
            </p>
            <Link
              to={this.state.url}
              title={this.props.fund.strategy_name}
            >
              <Grade grade={this.props.fund.grade_gender_equality} square />
            </Link>
          </div>

          <div styleName='target-date-grid-item__grade'>
            <p styleName='target-date-grid-item__grade-title'>
              Diversity Disclosures
            </p>
            <Link
              to={this.state.url}
              title={this.props.fund.strategy_name}
            >
              <Grade grade={this.props.fund.grade_dei} square />
            </Link>
          </div>

          <div styleName='target-date-grid-item__grade'>
            <p styleName='target-date-grid-item__grade-title'>
              Racial Justice
            </p>
            <Link
              to={this.state.url}
              title={this.props.fund.strategy_name}
            >
              <Grade grade={this.props.fund.grade_rji} square />
            </Link>
          </div>

          <div styleName='target-date-grid-item__grade'>
            <p styleName='target-date-grid-item__grade-title'>
              LGBTQ+ Equity
            </p>
            <Link
              to={this.state.url}
              title={this.props.fund.strategy_name}
            >
              <Grade grade={this.props.fund.grade_hrc} square />
            </Link>
          </div>
        </div>
      </div>
    </div>
  }
}

@connect(
  state => ({
    result: state.fundsByStrategy.result,
    searching: state.fundsByStrategy.loading,
    searched: state.fundsByStrategy.loaded,
    error: state.fundsByStrategy.error
  }),
  searchActions)
@CSSModules(Styles, {allowMultiple:true})
export default class SjfTargetDateGrid extends Component {
  static propTypes = {
    searching: PropTypes.bool,
    searched: PropTypes.bool,
    error: PropTypes.object,
    result: PropTypes.array,
  }

  constructor(props){
    super(props)
    this.state = {
      targetDateSeriesList: [].concat(config.targetDateSeries),
      fundsByStrategy: {}
    }
  }
  //
  componentWillMount() {
    if (typeof window !== 'undefined') {
      window.scrollTo(0,0)
    }
    // unique strategy names of each target date series
    const strategy_names = [...new Set(config.targetDateSeries.map((x) => x.strategy_name))]
    // call API
    this.props.getFundsByStrategy(strategy_names)
  }
  //
  componentWillReceiveProps(nextProps) {
    this.groupSortFundsSetState(nextProps.result)
  }
  groupSortFundsSetState = (f) => {
    const groupedSortedFunds = this.groupSortFunds(f)
    if (groupedSortedFunds) {
      this.setState({fundsByStrategy: groupedSortedFunds})
    }
  }
  //
  groupSortFunds = (f) => {
    const d = {}
    if (
      f &&
      Array.isArray(f) &&
      f.length > 0
    ) {
      for (let i = 0; i < f.length; i++) {
        const currFund = f[i]
        const currStrategy = currFund.strategy_name
        if (!(d[currStrategy] && Array.isArray(d[currStrategy]))) {
          d[currStrategy] = []
        }
        d[currStrategy].push(currFund)
      }
      //
      for (let p = 0; p < Object.keys(d).length; p++) {
        const sortStrategy = Object.keys(d)[p]
        const currFundsList = d[sortStrategy]
        currFundsList.sort((a, b) => a.fund_legal_name.localeCompare(b.fund_legal_name))
        d[sortStrategy] = currFundsList
      }
      return d
    }
    return null
  }

  //
  render() {
    if (!this.props.result) {
      //
      return <div style={{position: 'relative'}}>
        <Loader
          options={{scale: 0.70, position:'absolute', top:'4.0rem'}}
          loaded={ false }
        />
      </div>
    }

    const { targetDateSeriesList } = this.state

    //
    return <div styleName='companies'>
      <div styleName='companies-anchor' id='companies'/>
      <div styleName='companies-inner'>
        <div styleName='companies-title'>
          Target date funds
        </div>
        <div styleName='companies-info'>
          Target date funds are groups of funds where each portfolio in the
          series targets a different mix of stocks and bonds for investors with
          different retirement time horizons. Employer-offered retirement plans
          often use target date funds as the plan's "default option".
          Listed below are {config.targetDateSeries.length} of the largest
          target date series, each rated using the 2050 portfolio.
        </div>

        <div styleName='companies-boxes'>
          {
            targetDateSeriesList.map((fund, idx) =>{
              return <TargetDateGridItem
                key={'target-date-grid-item-' + idx}
                fund={fund}
                funds={this.state.fundsByStrategy[fund.strategy_name]}
              />
            })
          }
        </div>

        <div styleName='sjf-target-date-grid__more-link'>
          <Link
            roundbutton
            title='More target date funds'
            to={`${config.routes.clean}&td=1`}
          >
            More target date funds
          </Link>
        </div>

      </div>
    </div>
  }
}
